import React from 'react';
import PropTypes from 'prop-types';

import Error from './Error';
import Input from './Input';
import style from './InputWithLabel.module.css';

const InputWithLabel = React.memo(
  ({
    name,
    label = '',
    placeholder = '',
    value = '',
    autocomplete = 'on',
    error = '',
    styles,
    styleLabel,
    type,
    'data-testid': testId,
    onChange,
  }) => {
    return (
      <div className={`form-group ${style.formGroup}`}>
        <label className={`${style.label} ${styleLabel}}`} htmlFor={name}>
          {label}
          <Input
            onChange={onChange}
            placeholder={placeholder}
            value={value}
            autocomplete={autocomplete}
            id={name}
            name={name}
            styles={styles}
            type={type}
            data-testid={testId}
          />
          <Error error={error} />
        </label>
      </div>
    );
  },
);

InputWithLabel.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string,
  placeholder: PropTypes.string,
  value: PropTypes.string,
  error: PropTypes.string,
  autocomplete: PropTypes.string,
  onChange: PropTypes.func.isRequired,
};

export default InputWithLabel;
